import { type MaybeRefOrGetter, computed, toValue } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'
import { useMediaQuery } from '@vueuse/core'

export function useVisibleProducts<T>(products: MaybeRefOrGetter<T[]>) {
  const breakpoint = useClientOnlyComputedBreakpoint()
  const is2xl = useMediaQuery('(min-width: 1536px)')

  const visibleProducts = computed(() => {
    const list = toValue(products)

    if (is2xl.value) return list.slice(0, 6)
    if (breakpoint.value >= Breakpoint.LG) return list.slice(0, 5)
    if (breakpoint.value >= Breakpoint.MD) return list.slice(0, 4)

    return list.slice(0, 3)
  })

  return { visibleProducts }
}
